import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowser } from '@angular/platform-browser' // Optimized: no dynamic compiler
import * as Sentry from '@sentry/angular'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

// Sentry Initialization
if (environment.sentryEnabled) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.production ? 'production' : 'development',
    tracesSampleRate: environment.sentryTracesSampleRate ?? 1.0,
    sampleRate: environment.sentrySampleRate ?? 1.0,
    beforeSend(event, hint) {
      // Ignore 4xx errors more cleanly
      const is4xx = event.message && /4\d{2}/.test(event.message)
      return is4xx ? null : event
    },
    integrations: [],
  })
}

// Clean Bootstrap
platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))
